import StyledSpinner from '../../Spinner/Spinner.js';
import { clsx } from 'clsx';
import styles from './TextInputInnerVisualSlot.module.css.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const TextInputInnerVisualSlot = ({
  children,
  hasLoadingIndicator,
  showLoadingIndicator,
  visualPosition,
  id
}) => {
  const isLeading = visualPosition === 'leading';
  if (!children && !hasLoadingIndicator || isLeading && !children && !showLoadingIndicator) {
    return null;
  }
  if (!hasLoadingIndicator) {
    return /*#__PURE__*/jsx("span", {
      className: "TextInput-icon",
      id: id,
      "aria-hidden": "true",
      children: children
    });
  }
  return /*#__PURE__*/jsx("span", {
    className: "TextInput-icon",
    children: /*#__PURE__*/jsxs("div", {
      className: styles.Box,
      id: id,
      children: [children && /*#__PURE__*/jsx("div", {
        className: clsx(showLoadingIndicator ? styles.SpinnerHidden : styles.SpinnerVisible),
        children: children
      }), /*#__PURE__*/jsx(StyledSpinner, {
        srText: null,
        className: clsx(showLoadingIndicator ? styles.SpinnerVisible : styles.SpinnerHidden, children && styles.Spinner, children && isLeading && styles.SpinnerLeading),
        size: children ? undefined : 'small'
      })]
    })
  });
};
TextInputInnerVisualSlot.displayName = "TextInputInnerVisualSlot";

export { TextInputInnerVisualSlot as default };
